import { cn } from '@discover-lib/utils';

export type RootProps = React.ComponentPropsWithoutRef<'div'>;

export default function Root({ className, ...props }: RootProps) {
  return (
    <div
      className={cn('flex flex-row items-center text-base font-semibold text-black', className)}
      {...props}
    />
  );
}
